import { prop } from 'datx';
import { Resource } from 'datx-jsonapi-react';

export class CaseStudyCategory extends Resource {
  public static type = 'case_study_categories';

  @prop
  public name: string;
}
